const SAUDI_COUNTRY_ALIASES = ['sa', 'ksa', 'saudi arabia', 'saudi']

const isSaudiCountry = (country: string | null | undefined): boolean => {
  if (!country) return false
  return SAUDI_COUNTRY_ALIASES.includes(country.toLowerCase())
}

// Semantic aliases so call sites read as origin/destination intent while
// sharing a single source of truth for the accepted country strings.
export const isDestinationSaudi = isSaudiCountry
export const isOriginSaudi = isSaudiCountry

export const isSaudiDomestic = (
  originCountry: string | null | undefined,
  destinationCountry: string | null | undefined
): boolean =>
  isOriginSaudi(originCountry) && isDestinationSaudi(destinationCountry)

export const getCurrency = (country: string | null | undefined): string =>
  isOriginSaudi(country) ? 'SAR' : 'AED'
